import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfigService } from '../../shared-services/config.service';
import { GlobalFilterService } from '../../shared-services/global-filter-service';
import { Subscription } from 'rxjs';
import { ConfirmationDialogService } from '../../shared-services/confirmation-dialog.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SearchContainerComponent } from '../../global-components/search-container/search-container.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { Output, EventEmitter } from '@angular/core';
import { RouterModule } from '@angular/router';
interface ColumnConfig {
  key: string;
  label?: string;
  type?: string;
  isDropdown?: boolean;
  options?: any[];
  optionsList?: any[];
  apiUrl?: string;
  method?: string;
  payload?: any;
  responseKey?: string;
  optionsField?: string;
  displayField?: string;
  valueField?: string;
  placeholder?: string;
  defaultToFirstOption?: boolean;
}

interface DropdownOption {
  label: string;
  value: any;
  raw?: any;
}

@Component({
  selector: 'app-dynamic-edit-table',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, SearchContainerComponent, MatSelectModule, MatFormFieldModule, FormsModule, RouterModule],
  templateUrl: './dynamic-edit-table.component.html',
  styleUrl: './dynamic-edit-table.component.scss'
})
export class DynamicEditTableComponent implements OnInit, OnDestroy {

  @Input() isChat: boolean = false;
  @Input() data: any;
  multipleTables: { tableData: any[]; columns: string[]; fileName?: string | null; isError?: boolean; isResultTable?: boolean; }[] = [];
  loading = true;
  showAddButton = false;
  shouldRender = false;
  currentFilters: any = {};
  fileName: string | null = null;
  isSubmitDisabled = true;
  isAddRecordDisabled = false;
  isTableLocked = false;
  optimizedPrice: string | null = null;
  selectedRationalizeKeys: Array<'size' | 'material' | 'type'> = ['size'];
  title: string | null = null;
  margin_top: string | null = null;
  optimizedPrices: boolean = false;
  showlastTables: string | null = null;
  ExtraDropdown: string | null = null;
  sroFlowTrue: string | null = null;
  showlinks: string | null = null;
  @Output() submitSuccess = new EventEmitter<{ widgetId: string }>();

  columnConfigMap: Record<string, ColumnConfig> = {};
  dropdownOptionsMap: Record<string, DropdownOption[]> = {};
  dropdownLoadingMap: Record<string, boolean> = {};




  private filterSub?: Subscription;
  private tableData: any[] = [];
  private tableDataSubscription!: Subscription;
  private resetStateSubscription?: Subscription;

  get isEditable(): boolean {
    return this.data?.isEditable && !this.isTableLocked;
  }
  get showRationalizeDropdown(): boolean {
    console.log("inside condition for shwoing the dropdown ");
    return !!this.data?.dropdown;
  }
  goToAIGeneratedPrice() {
    this.router.navigateByUrl('/AI');
  }
  get hasExtraDropdown(): boolean {
    return this.data?.showExtraDropdownColumn === true
      && !!this.data?.extraDropdown?.key
      && !!this.data?.extraDropdown?.options?.length;
  }

  get extraDropdownConfig() {
    return this.data?.extraDropdown || {};
  }




  constructor(
    private configService: ConfigService,
    private globalFilterService: GlobalFilterService,
    private http: HttpClient,
    private dialogService: ConfirmationDialogService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }


  ngOnInit(): void {
    this.ExtraDropdown = this.data?.extraDropdown;
    this.initializeColumnConfig();
    this.loadColumnDropdownOptions();
    // configCols = this.data?.columns || [];
    // this.showRationalizeDropdown;
    this.tableDataSubscription = this.globalFilterService.tableData$.subscribe((data) => {
      console.log('Received data in DynamicEditTableComponent:', data);
      if (!data) {
        console.log('No data received in DynamicEditTableComponent');
      } else {
        console.log('Data received:', data);
      }
      this.tableData = data; // Set the received data to tableData
    });
    this.resetStateSubscription = this.globalFilterService.resetState$.subscribe(() => {
      this.resetTableState();
    });

    console.log("tableData", this.tableData);
    this.title = this.data?.title;
    this.margin_top = this.data?.actions?.margin_top;
    this.optimizedPrices = this.data?.optimizedPrices;

    const def = this.data?.dropdownDefault;
    if (def === 'size' || def === 'material' || def === 'type') {
      this.selectedRationalizeKeys = def;
    }
    this.filterSub = this.globalFilterService.filter$.subscribe((filters) => {
      console.log('1 ngonit', filters);
      const isReset = !filters.changedFilterKey &&
        Object.keys(filters.queryParams).length === 0 &&
        Object.keys(filters.requestParams).length === 0;

      if (isReset) {
        console.log('2 isreset', isReset);
        if ((this.data.dependsOnFilters && this.data.dependsOnFilters.length > 0) || this.data.searchable) {
          console.log('3 multipletables', this.multipleTables);
          this.multipleTables = [];
        }
        return;
      }

      let shouldReload = false;
      if (this.data.searchable && filters.changedFilterKey === 'search') {
        shouldReload = true;
      } else if (this.data.dependsOnFilters?.includes(filters.changedFilterKey)) {
        shouldReload = true;
      }

      if (!shouldReload) return;

      this.currentFilters = filters;
      const params = { ...filters?.requestParams, ...filters?.queryParams };
      console.log('4 params', params);
      this.fileName = params.data_file || params.fileName || params.file || null;
      console.log('5 fileName', this.fileName);
      this.checkRenderCondition(filters);
      if (this.shouldRender) {
        console.log('6 shouldRender');
        this.loadAndRenderTable(filters);
        this.checkShowAddButton(filters);
      }
    });

    this.currentFilters = this.globalFilterService.getCurrentFilters();
    const currentParams = { ...this.currentFilters?.requestParams, ...this.currentFilters?.queryParams };
    this.fileName = currentParams.data_file;
    this.checkRenderCondition(this.currentFilters);
    if (this.shouldRender) {
      this.loadAndRenderTable(this.currentFilters);
      this.checkShowAddButton(this.currentFilters);
    }


  }


  // getActionsForGroup(groupName: string): any[] {
  //   return this.data?.actions?.filter(a => a.group === groupName) || [];
  // }



  onRationalizeKeysChange(event: Event): void {
    const selectEl = event.target as HTMLSelectElement;
    const values = Array.from(selectEl.selectedOptions).map(o => o.value);

    this.selectedRationalizeKeys = values.filter(
      (v): v is 'size' | 'material' | 'type' => v === 'size' || v === 'material' || v === 'type'
    );
  }


  private checkRenderCondition(filters: any): void {
    console.log('7 checkRenderCondition');
    const condition = this.data?.renderCondition;
    if (!condition) {
      this.shouldRender = true;
      return;
    }
    if (condition.filter && condition.is) {
      console.log('8 condition');
      const requiredValues = Array.isArray(condition.is) ? condition.is : [condition.is];
      const filterKey = condition.filter;
      const valueFromFilters = filters?.queryParams?.[filterKey] || filters?.requestParams?.[filterKey];
      if (valueFromFilters === undefined) {
        this.shouldRender = requiredValues.includes('get_record');
        return;
      }
      const currentValues = Array.isArray(valueFromFilters) ? valueFromFilters : [valueFromFilters];
      this.shouldRender = currentValues.some(v => requiredValues.includes(v));
    } else {
      console.error(" 9 Malformed renderCondition:", this.data);
      this.shouldRender = true;
    }
  }

  private checkShowAddButton(filters: any): void {
    const condition = this.data?.addRowCondition;
    if (condition && condition.filter && condition.is) {
      const requiredValues = Array.isArray(condition.is) ? condition.is : [condition.is];
      const filterKey = condition.filter;
      const valueFromFilters = filters?.queryParams?.[filterKey] || filters?.requestParams?.[filterKey];
      const currentValues = Array.isArray(valueFromFilters) ? valueFromFilters : (valueFromFilters ? [valueFromFilters] : []);
      this.showAddButton = currentValues.some(v => requiredValues.includes(v));
    } else {
      this.showAddButton = false;
    }
  }
  get hasInputTable(): boolean {
    return this.multipleTables?.some(t => !t.isResultTable);
  }


  addRow(tableIndex: number): void {
    if (this.multipleTables[tableIndex]) {
      const table = this.multipleTables[tableIndex];
      const emptyRow = table.columns.reduce((acc, col) => ({ ...acc, [col]: '' }), {});
      const newTableData = [...table.tableData, emptyRow];
      this.multipleTables = [
        ...this.multipleTables.slice(0, tableIndex),
        { ...table, tableData: newTableData },
        ...this.multipleTables.slice(tableIndex + 1),
      ];
      this.persistWidgetTableData();
    }
  }

  private formatFileName(name: string | null): string {
    if (!name) return '';
    const lastDotIndex = name.lastIndexOf('.');
    const baseName = lastDotIndex > 0 ? name.substring(0, lastDotIndex) : name;
    return baseName.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
  }

  public isTableEditable(): boolean {
    return this.isEditable;
  }

  public getTableData(): any[] {
    return this.multipleTables.map(table => table.tableData);
  }

  private loadAndRenderTable(filters?: any): void {
    console.log(' 10 loadAndRenderTable', filters);
    if (!this.data?.apiUrl) return;
    this.loading = true;

    const modifiedFilters: any = {
      ...filters,
      queryParams: { ...(filters?.queryParams || {}) },
      requestParams: { ...(filters?.requestParams || {}) },
    };

    if (this.data.searchable && modifiedFilters.requestParams?.search) {
      modifiedFilters.rawQueryString = modifiedFilters.requestParams.search[0];
      delete modifiedFilters.requestParams.search;
      modifiedFilters.queryParams = {};
    }

    this.configService.getApi(this.data.apiUrl, modifiedFilters, this.data, this.data?.method || 'post').subscribe({
      next: (res: any) => {
        console.log('11 res', res);
        const key = this.data?.key || 'data';
        const responseData = res?.[key] || res;
        const newTableCollection: any[] = [];
        const configuredColumnKeys = this.getConfiguredColumnKeys();

        const isMultiTableResponse = Array.isArray(responseData) && responseData.length > 0 && Array.isArray(responseData[0]);
        const tableDataSets = isMultiTableResponse ? responseData : [responseData];
        const fileNames = this.fileName ? (Array.isArray(this.fileName) ? this.fileName : [this.fileName]) : [];

        tableDataSets.forEach((apiTableData, index) => {
          const rawFileName = fileNames[index] || null;
          const formattedFileName = this.formatFileName(rawFileName);

          const configCols = this.data?.columns || []; // [{key,label}]
          const labelMap: Record<string, string> = {};
          configCols.forEach((c: any) => labelMap[c.key] = c.label || c.key);

          let columns: string[] = [];
          let initialTableData: any[] = [];
          let isError = false;

          const keyColumns = columns;
          const displayColumns = keyColumns.map(k => labelMap[k] || k);

          const isErrorObjectInArray = Array.isArray(apiTableData) &&
            apiTableData.length === 1 &&
            typeof apiTableData[0] === 'object' &&
            apiTableData[0] !== null &&
            'error' in apiTableData[0];

          if (isErrorObjectInArray) {
            columns = ['Error'];
            initialTableData = [{ Error: apiTableData[0].error }];
            isError = true;
          } else if (Array.isArray(apiTableData)) {
            const isHeaderOnly = apiTableData.length > 0 && apiTableData.every(item => {
              if (typeof item !== 'object' || item === null) return false;
              const keys = Object.keys(item);
              return keys.length === 1 && (item[keys[0]] === '' || item[keys[0]] === null);
            });

            if (isHeaderOnly) {
              columns = configuredColumnKeys.length > 0
                ? [...configuredColumnKeys]
                : apiTableData.map(item => Object.keys(item)[0]);
              const emptyRow = columns.reduce((acc, col) => ({ ...acc, [col]: '' }), {});
              initialTableData = Array(1).fill(null).map(() => ({ ...emptyRow }));
            } else {
              initialTableData = apiTableData;
              if (configuredColumnKeys.length > 0) {
                columns = [...configuredColumnKeys];
                initialTableData = this.normalizeRowsToColumns(initialTableData, columns);
              } else if (initialTableData.length > 0 && typeof initialTableData[0] === 'object' && initialTableData[0] !== null) {
                columns = Object.keys(initialTableData[0]);
              }
            }
          }

          newTableCollection.push({
            columns,
            tableData: initialTableData,
            fileName: formattedFileName,
            isError: isError,
            isResultTable: false
          });
        });

        this.multipleTables = this.applyCachedWidgetRows(newTableCollection);
        this.applyDropdownDefaults();
        this.persistWidgetTableData();
        this.loading = false;
        this.isSubmitDisabled = false;
      },
      error: (err) => {
        this.loading = false;
        this.multipleTables = [];
        const errorMessage = (err.error && typeof err.error === 'string')
          ? err.error
          : (err.error?.message || err.message || 'An unknown error occurred.');
        this.snackBar.open(errorMessage, 'Close', {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
          panelClass: ['error-snackbar']
        });
      }
    });
  }

  private initializeColumnConfig(): void {
    const configColumns: ColumnConfig[] = Array.isArray(this.data?.columns) ? this.data.columns : [];
    this.columnConfigMap = configColumns.reduce((acc: Record<string, ColumnConfig>, column: ColumnConfig) => {
      if (column?.key) {
        acc[column.key] = column;
      }
      return acc;
    }, {});
  }

  private isDropdownColumnConfig(column?: ColumnConfig): boolean {
    return column?.type === 'dropdown' || column?.isDropdown === true;
  }

  isColumnDropdown(columnKey: string): boolean {
    return this.isDropdownColumnConfig(this.columnConfigMap[columnKey]);
  }

  getColumnHeaderLabel(columnKey: string): string {
    const configuredLabel = String(this.columnConfigMap[columnKey]?.label || '').trim();
    return this.formatHeaderLabel(configuredLabel || columnKey);
  }

  private formatHeaderLabel(value: any): string {
    const raw = String(value ?? '').trim();
    if (!raw) {
      return '';
    }

    const normalized = raw
      .replace(/[_-]+/g, ' ')
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim();

    return normalized
      .split(' ')
      .map((word) => {
        if (!word) {
          return word;
        }

        const leading = (word.match(/^[^A-Za-z0-9]*/) || [''])[0];
        const trailing = (word.match(/[^A-Za-z0-9]*$/) || [''])[0];
        const core = word.slice(leading.length, word.length - trailing.length);
        if (!core) {
          return word;
        }

        if (/^[A-Z0-9]{1,3}$/.test(core)) {
          return `${leading}${core}${trailing}`;
        }

        const lowerCore = core.toLowerCase();
        const titleCore = lowerCore.charAt(0).toUpperCase() + lowerCore.slice(1);
        return `${leading}${titleCore}${trailing}`;
      })
      .join(' ');
  }

  getColumnDropdownOptions(columnKey: string): DropdownOption[] {
    return this.dropdownOptionsMap[columnKey] || [];
  }

  getDropdownPlaceholder(columnKey: string): string {
    const column = this.columnConfigMap[columnKey];
    const configuredPlaceholder = String(column?.placeholder || '').trim();
    if (configuredPlaceholder) {
      return configuredPlaceholder;
    }

    const label = String(column?.label || columnKey || '').trim();
    return label ? `Select ${label}` : 'Select';
  }

  onCellDropdownChange(row: any, columnKey: string, value: any): void {
    row[columnKey] = value;
    this.isSubmitDisabled = false;

    if (columnKey === 'customer') {
      const customerOption = this.resolveDropdownOption(columnKey, value);
      const runningQtyRaw = customerOption?.raw?.running_qty ?? customerOption?.raw?.runningQty;
      const runningQty = Array.isArray(runningQtyRaw) ? runningQtyRaw[0] : runningQtyRaw;

      this.globalFilterService.setWorkflowCtx({
        customer: value,
        ...(runningQty !== undefined && runningQty !== null && runningQty !== '' ? { running_qty: runningQty } : {})
      });
    }

    this.persistWidgetTableData();
  }

  private normalizeComparableValue(value: any): string {
    return String(value ?? '').replace(/\uFEFF/g, '').trim();
  }

  private resolveDropdownOption(columnKey: string, selectedValue: any): DropdownOption | null {
    const options = this.getColumnDropdownOptions(columnKey);
    if (!options.length) {
      return null;
    }

    const directMatch = options.find((option) => option.value === selectedValue);
    if (directMatch) {
      return directMatch;
    }

    const normalizedSelected = this.normalizeComparableValue(selectedValue);
    return options.find((option) => this.normalizeComparableValue(option.value) === normalizedSelected) || null;
  }

  private loadColumnDropdownOptions(): void {
    const configColumns: ColumnConfig[] = Array.isArray(this.data?.columns) ? this.data.columns : [];
    const dropdownColumns = configColumns.filter((column) => this.isDropdownColumnConfig(column));

    dropdownColumns.forEach((column) => {
      const staticOptions = column.options || column.optionsList;
      if (Array.isArray(staticOptions) && staticOptions.length > 0) {
        this.dropdownOptionsMap[column.key] = this.normalizeDropdownOptions(staticOptions, column);
        this.applyDropdownDefaults();
        return;
      }

      if (!column.apiUrl) {
        this.dropdownOptionsMap[column.key] = [];
        return;
      }

      const method = (column.method || 'POST').toUpperCase();
      const payload = column.payload || {};
      this.dropdownLoadingMap[column.key] = true;

      const request$ = method === 'GET'
        ? this.http.get(column.apiUrl, { params: this.buildHttpParams(payload) })
        : this.http.post(column.apiUrl, payload);

      request$.subscribe({
        next: (response: any) => {
          this.dropdownOptionsMap[column.key] = this.extractDropdownOptions(response, column);
          this.dropdownLoadingMap[column.key] = false;
          this.applyDropdownDefaults();
        },
        error: (error: any) => {
          console.error(`[DynamicEditTable] Failed to load dropdown options for ${column.key}`, error);
          this.dropdownOptionsMap[column.key] = [];
          this.dropdownLoadingMap[column.key] = false;
        }
      });
    });
  }

  private buildHttpParams(payload: any): HttpParams {
    let params = new HttpParams();

    if (!payload || typeof payload !== 'object') {
      return params;
    }

    Object.entries(payload).forEach(([key, rawValue]) => {
      if (rawValue === undefined || rawValue === null) {
        return;
      }

      if (Array.isArray(rawValue)) {
        rawValue.forEach((value) => {
          params = params.append(key, String(value));
        });
        return;
      }

      params = params.set(key, String(rawValue));
    });

    return params;
  }

  private extractDropdownOptions(response: any, column: ColumnConfig): DropdownOption[] {
    const responseKey = column.responseKey || 'data';
    let rawOptions = response?.[responseKey] ?? response?.data ?? response;

    if (column.optionsField && rawOptions && typeof rawOptions === 'object' && !Array.isArray(rawOptions)) {
      rawOptions = rawOptions[column.optionsField];
    }

    const optionArray = Array.isArray(rawOptions)
      ? rawOptions
      : (rawOptions !== undefined && rawOptions !== null ? [rawOptions] : []);

    return this.normalizeDropdownOptions(optionArray, column);
  }

  private normalizeDropdownOptions(options: any[], column: ColumnConfig): DropdownOption[] {
    const displayField = column.displayField;
    const valueField = column.valueField || displayField;

    return options
      .map((option: any): DropdownOption | null => {
        if (option === undefined || option === null) {
          return null;
        }

        if (typeof option !== 'object') {
          return {
            label: String(option),
            value: option,
            raw: option
          };
        }

        const keys = Object.keys(option);
        if (!keys.length) {
          return null;
        }

        const fallbackKey = keys[0];
        const labelKey = displayField || valueField || fallbackKey;
        const valueKey = valueField || displayField || fallbackKey;

        const labelValue = option[labelKey] ?? option[valueKey];
        const valueValue = option[valueKey] ?? option[labelKey];

        if (labelValue === undefined && valueValue === undefined) {
          return null;
        }

        return {
          label: String(labelValue ?? valueValue),
          value: valueValue ?? labelValue,
          raw: option
        };
      })
      .filter((option): option is DropdownOption => option !== null);
  }

  private applyDropdownDefaults(): void {
    if (!Array.isArray(this.multipleTables) || this.multipleTables.length === 0) {
      return;
    }

    this.multipleTables.forEach((table) => {
      if (!Array.isArray(table.tableData)) {
        return;
      }

      table.tableData.forEach((row: any) => {
        if (!row || typeof row !== 'object') {
          return;
        }

        table.columns.forEach((columnKey: string) => {
          if (!this.isColumnDropdown(columnKey)) {
            return;
          }

          const options = this.getColumnDropdownOptions(columnKey);
          if (!options.length) {
            return;
          }

          const columnConfig = this.columnConfigMap[columnKey];
          const shouldDefaultToFirst = columnConfig?.defaultToFirstOption !== false;
          const currentValue = row[columnKey];
          if (currentValue === undefined || currentValue === null || currentValue === '') {
            row[columnKey] = shouldDefaultToFirst ? options[0].value : null;
          }
        });
      });
    });
  }

  onCellEdit(row: any, columnKey: string, event: any): void {
    row[columnKey] = event.target.value;
    this.isSubmitDisabled = false;
    this.persistWidgetTableData();
  }

  isActionVisible(action: any): boolean {
    const condition = action.showOn;
    if (!condition || !condition.filter || !condition.is) return true;
    const requiredValues = Array.isArray(condition.is) ? condition.is : [condition.is];
    const filterKey = condition.filter;
    const valueFromFilters = this.currentFilters?.queryParams?.[filterKey] || this.currentFilters?.requestParams?.[filterKey];
    if (valueFromFilters === undefined) return false;
    const currentValues = Array.isArray(valueFromFilters) ? valueFromFilters : [valueFromFilters];
    return currentValues.some(v => requiredValues.includes(v));
  }
  openImage() {
    window.open('assets/Chart.png', '_blank');
  }
  openImage2() {
    window.open('assets/A.png', '_blank');
  }

  private renderTableFromResponse(res: any, append: boolean = true): void {
    console.log('Rendering table from response:', res);

    let parsed = res;

    if (typeof res === 'string') {
      console.log('Response is a string, attempting to parse JSON');
      try {
        parsed = JSON.parse(res);
        console.log('Parsed JSON:', parsed);
      } catch {
        console.error('Failed to parse response as JSON');
        const fallback = {
          columns: ['Response'],
          tableData: [{ Response: res }],
          fileName: this.formatFileName(this.fileName),
          isError: false
        };

        this.multipleTables = append ? [...this.multipleTables, fallback] : [fallback];
        return;
      }
    }

    const key = this.data?.key || 'data';
    console.log('Key for response data:', key);
    const responseData = parsed?.[key] ?? parsed;
    console.log('Response data extracted:', responseData);

    const newTableCollection: any[] = [];

    const isMultiTableResponse =
      Array.isArray(responseData) &&
      responseData.length > 0 &&
      Array.isArray(responseData[0]);

    console.log('Is multi-table response:', isMultiTableResponse);

    const tableDataSets = isMultiTableResponse ? responseData : [responseData];
    const configuredColumnKeys = this.getConfiguredColumnKeys();
    console.log('Table data sets:', tableDataSets);

    tableDataSets.forEach((apiTableData: any, index: number) => {
      console.log(`Processing table data for index: ${index}`, apiTableData);

      let columns: string[] = [];
      let initialTableData: any[] = [];
      let isError = false;

      // ───────────────────────────────
      // Directly use the keys as table headers
      // ───────────────────────────────
      if (Array.isArray(apiTableData)) {
        initialTableData = apiTableData;
        if (configuredColumnKeys.length > 0) {
          columns = [...configuredColumnKeys];
          initialTableData = this.normalizeRowsToColumns(initialTableData, columns);
        } else if (initialTableData.length > 0 && typeof initialTableData[0] === 'object' && initialTableData[0] !== null) {
          // Use the keys of the first object in the array as the table columns
          columns = Object.keys(initialTableData[0]);
        }
      } else if (typeof apiTableData === 'object' && apiTableData !== null) {
        initialTableData = [apiTableData];
        if (configuredColumnKeys.length > 0) {
          columns = [...configuredColumnKeys];
          initialTableData = this.normalizeRowsToColumns(initialTableData, columns);
        } else {
          // Use the keys of the object as the table columns
          columns = Object.keys(apiTableData);
        }
      } else {
        columns = ['Value'];
        initialTableData = [{ Value: apiTableData }];
      }

      // File name logic
      const rawFileName = this.fileName
        ? Array.isArray(this.fileName)
          ? this.fileName[index] ?? null
          : this.fileName
        : null;
      const formattedFileName = this.formatFileName(rawFileName) || 'Standardize (Base Product Suggestion)';
      console.log('Formatted file name:', formattedFileName);

      newTableCollection.push({
        columns,
        tableData: initialTableData,
        fileName: formattedFileName,
        isError,
        isResultTable: false
      });
      console.log('New table collection after processing:', newTableCollection);
    });

    console.log('Final new table collection:', newTableCollection);

    this.multipleTables = append ? [...this.multipleTables, ...newTableCollection] : newTableCollection;
    this.persistWidgetTableData();
    console.log('Updated multiple tables:', this.multipleTables);
  }

  private getConfiguredColumnKeys(): string[] {
    const configColumns = Array.isArray(this.data?.columns) ? this.data.columns : [];
    return configColumns
      .map((column: any) => String(column?.key || '').trim())
      .filter((key: string) => key.length > 0);
  }

  private normalizeRowsToColumns(rows: any[], columnKeys: string[]): any[] {
    if (!Array.isArray(rows) || !Array.isArray(columnKeys) || columnKeys.length === 0) {
      return Array.isArray(rows) ? rows : [];
    }

    return rows.map((row: any) => {
      const source = row && typeof row === 'object' ? row : {};
      return columnKeys.reduce((acc: Record<string, any>, key: string) => {
        acc[key] = source[key] ?? '';
        return acc;
      }, {});
    });
  }

  private applyCachedWidgetRows(tableCollection: any[]): any[] {
    if (!Array.isArray(tableCollection) || tableCollection.length === 0) {
      return tableCollection;
    }

    const widgetId = String(this.data?.widgetId || '').trim();
    if (!widgetId) {
      return tableCollection;
    }

    const cachedRows = this.globalFilterService.getWidgetData(widgetId);
    if (!Array.isArray(cachedRows) || cachedRows.length === 0) {
      return tableCollection;
    }

    const inputTableIndex = tableCollection.findIndex((table) => !table?.isResultTable);
    if (inputTableIndex < 0) {
      return tableCollection;
    }

    return tableCollection.map((table, index) => {
      if (index !== inputTableIndex) {
        return table;
      }

      return {
        ...table,
        tableData: cachedRows.map((row: any) => ({ ...row }))
      };
    });
  }

  private persistWidgetTableData(): void {
    const widgetId = String(this.data?.widgetId || '').trim();
    if (!widgetId) {
      return;
    }

    const inputTable = this.multipleTables.find((table) => !table?.isResultTable);
    const rows = Array.isArray(inputTable?.tableData)
      ? inputTable.tableData.map((row: any) => ({ ...row }))
      : [];

    this.globalFilterService.setWidgetData(widgetId, rows);
  }

  private resetTableState(): void {
    if (!Array.isArray(this.multipleTables) || this.multipleTables.length === 0) {
      const configuredColumns = Array.isArray(this.data?.columns)
        ? this.data.columns.map((column: any) => column?.key).filter((key: any) => !!key)
        : [];

      if (configuredColumns.length > 0) {
        this.multipleTables = [{
          columns: configuredColumns,
          tableData: [this.buildEmptyRow(configuredColumns)],
          fileName: this.formatFileName(this.fileName),
          isError: false,
          isResultTable: false
        }];
      } else {
        this.multipleTables = [];
      }
    } else {
      this.multipleTables = this.multipleTables.map((table) => {
        const columns = Array.isArray(table?.columns) ? table.columns : [];
        const rowCount = Array.isArray(table?.tableData) && table.tableData.length > 0
          ? table.tableData.length
          : 1;

        const tableData = Array.from({ length: rowCount }, () => this.buildEmptyRow(columns));
        return {
          ...table,
          tableData
        };
      });
    }

    this.isSubmitDisabled = true;
    this.isAddRecordDisabled = false;
    this.isTableLocked = false;
    this.optimizedPrice = null;
    this.showlastTables = null;
    this.showlinks = null;
    this.persistWidgetTableData();
  }

  private buildEmptyRow(columns: string[]): Record<string, any> {
    return columns.reduce((acc: Record<string, any>, column: string) => {
      acc[column] = this.isColumnDropdown(column) ? null : '';
      return acc;
    }, {});
  }




  handleAction(action: any): void {
    const performAction = () => {
      let payload: any = {};
      const options: any = {};

      if (action.apiUrl) {
        // Prepare payload and query params
        if (action.label === 'Cancel' || action.label === 'Submit') {
          const queryParams = this.currentFilters.queryParams;
          if (queryParams) options.params = new HttpParams({ fromObject: queryParams });
        } else {
          payload = this.multipleTables;
          const queryParams = this.currentFilters.queryParams;
          if (queryParams) options.params = new HttpParams({ fromObject: queryParams });
        }

        options.responseType = 'text';
        const isSubmit = action.label === 'Submit';
        const isSubmitPrice = action.label === 'submit_price';
        const isCalculatePrice = action.label === 'calculate_price';
        const isSubmitSingle = action.label === 'Submit_Single';
        const isSubmitCalculate = action.label === 'submit_calculate';
        let submittedRow: any = {};
        // Handle Submit immediately (pre-success flow)
        if (isSubmit || isSubmitPrice || isSubmitCalculate || isSubmitSingle || isCalculatePrice) {
          console.log('isSubmitPrice', isSubmitPrice);
          console.log("isSubmitSingle", isSubmitSingle)
          console.log("isSubmitCalculate", isSubmitCalculate)
          // Build payload from action.payload and merge row data
          // const row = this.multipleTables[0]?.tableData[0] || {};
          const inputTable = this.multipleTables.find(t => !t.isResultTable);
          const row = inputTable?.tableData?.[0] || {};
          submittedRow = row;
          if (isSubmitSingle) {
            if (this.shouldBlockSubmitSingleForMissingQuoteDetails(row)) {
              this.showQuoteDetailsRequiredMessage();
              return;
            }

            //  const itemToStore = Array.isArray(row.item) ? row.item[0] : row.item;
            const dealname = Array.isArray(row.quote_name) ? row.quote_name[0] : row.quote_name;
            const customer = Array.isArray(row.customer) ? row.customer[0] : row.customer;
            const location = Array.isArray(row.location) ? row.location[0] : row.location;
            const deal_start_date = Array.isArray(row.quote_start_date) ? row.quote_start_date[0] : row.quote_start_date;
            const deal_end_date = Array.isArray(row.quote_end_date) ? row.quote_end_date[0] : row.quote_end_date;
            const customerOption = this.resolveDropdownOption('customer', customer);
            const runningQtyRaw = customerOption?.raw?.running_qty ?? customerOption?.raw?.runningQty;
            const runningQty = Array.isArray(runningQtyRaw) ? runningQtyRaw[0] : runningQtyRaw;

            this.globalFilterService.setWorkflowCtx({
              quote_name: dealname,
              customer: customer,
              location: location,
              quote_start_date: deal_start_date,
              quote_end_date: deal_end_date,
              ...(runningQty !== undefined && runningQty !== null && runningQty !== '' ? { running_qty: runningQty } : {})
            });
          }
          else if (isSubmitCalculate) {
            this.showlastTables = "true";
            console.log("inside submit calculate")
            const ctx = this.globalFilterService.getWorkflowCtx();

            //   const dealname = Array.isArray(row.deal_name) ? row.deal_name[0] : row.deal_name;
            // const customer = Array.isArray(row.customer) ? row.customer[0] : row.customer; 
            // const location = Array.isArray(row.location) ? row.location[0] : row.location;
            // const deal_start_date = Array.isArray(row.deal_start_date) ? row.deal_start_date[0] : row.deal_start_date;
            // const deal_end_date = Array.isArray(row.deal_end_date) ? row.deal_end_date[0] : row.deal_end_date;

            // this.globalFilterService.setWorkflowCtx({deal_name: dealname, customer:customer, location:location, deal_start_date:deal_start_date, deal_end_date:deal_end_date });
            //             payload = {
            //   ...action.payload,
            //   requestData: {
            // ...action.payload.requestData,
            // // Adding the context values (from the setWorkflowCtx in isSubmitSingle)
            // deal_name: ctx.deal_name,
            // customer: ctx.customer,
            // location: ctx.location,
            // deal_start_date: ctx.deal_start_date,
            // deal_end_date: ctx.deal_end_date,
            // ...row ,
            // "deal_deatils":  this.tableData
            //   }
            // };
            payload = {
              responseList: {},
              entity: 'create_quote',
              workflowId: 'PRICE_OPT_WORKFLOW_001',
              endpoints: [{ functionName: 'DealDetailsSummaryService', version: '1.0' }],
              communicationType: 'rest',
              version: '1.0',
              requestData: {
                ...action.payload.requestData,
                quote_name: ctx.quote_name,
                customer: ctx.customer,
                location: ctx.location,
                quote_start_date: ctx.quote_start_date,
                quote_end_date: ctx.quote_end_date,
                ...row,
                "": this.tableData
              }
            };

            console.log("payload for submit calculate", payload);


          }
          else if (isSubmit) {
            this.sroFlowTrue = "true";
            //             [
            //     {
            //         "deal_name": "",
            //         "customer": "",
            //         "location": "",
            //         "deal_start_date": "",
            //         "deal_end_date": ""
            //     }
            // ]
            const itemToStore = Array.isArray(row.item) ? row.item[0] : row.item;
            // const dealname = Array.isArray(row.deal_name) ? row.deal_name[0] : row.deal_name;
            // const customer = Array.isArray(row.customer) ? row.customer[0] : row.customer; 
            // const location = Array.isArray(row.location) ? row.location[0] : row.location;
            // const deal_start_date = Array.isArray(row.deal_start_date) ? row.deal_start_date[0] : row.deal_start_date;
            // const deal_end_date = Array.isArray(row.deal_end_date) ? row.deal_end_date[0] : row.deal_end_date;

            this.globalFilterService.setWorkflowCtx({ item: itemToStore });
          }

          console.log('13 row', row);
          if (isSubmitPrice || isCalculatePrice) {
            this.showlinks = "true";
            const ctx = this.globalFilterService.getWorkflowCtx<{ item?: any }>();

            const itemValueRaw = (ctx?.item ?? row?.item);
            const itemValue = Array.isArray(itemValueRaw) ? itemValueRaw[0] : itemValueRaw;

            if (!itemValue) {
              this.snackBar.open('Item is missing. Please Submit Item Details first.', 'Close', {
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['error-snackbar']
              });
              return;
            }

            // ✅ PUT THIS HERE (replace the old loop)
            type RationalizeKey = 'size' | 'material' | 'type';

            const rationalize: Partial<Record<RationalizeKey, string>> = {};

            for (const k of this.selectedRationalizeKeys) {
              const v = String((row as Record<string, any>)?.[k] ?? '').trim(); // keeps "10%" as-is
              if (v !== '' && v !== '0') {
                rationalize[k] = v;
              }
            }



            payload = {
              responseList: {},
              entity: 'price_optimization',
              workflowId: 'PRICE_OPT_WORKFLOW_001',
              endpoints: [{ functionName: 'RationalizeOptimizePriceService', version: '1.0' }],
              communicationType: 'rest',
              version: '1.0',
              requestData: {
                item: String(itemValue),
                base_item: "Yes",
                ...(Object.keys(rationalize).length ? { rationalize } : {})
              }
            };
          }
          else if (isSubmitCalculate === false) {
            {

              console.log("inside else condition", "this.data.NoResponseTable", this.data.NoResponseTable, "isSubmitSingle", isSubmitSingle);
              payload = {
                ...action.payload,
                requestData: {
                  ...action.payload.requestData,
                  ...row
                }
              };
            }


            const itemValue = payload?.requestData?.item;
            console.log('itemValue', itemValue);
            console.log("payload", payload);
            console.log('payload requestData', payload.requestData);
            // "Sofa 03"
            // const secondPayload = {
            //   item: itemValue ? [itemValue] : []
            // };


            // Show immediate success message before actual API result
            if (!isSubmitSingle) {
              this.snackBar.open(
                'Workflow submitted successfully.',
                'Close',
                {
                  duration: 4000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['success-snackbar']
                }
              );
            }

            // Reset local UI states
            // this.multipleTables = [];
            this.isSubmitDisabled = false;
            this.isAddRecordDisabled = false;
            this.isTableLocked = false;

            // Navigate if specified
            if (!isSubmitSingle && action.navigateTo) {
              console.log('[DynamicEditTable] Navigating with row data:', row);
              const stateData = {
                submittedData: submittedRow,
                sourceWidgetId: this.data.widgetId,
                targetWidgetId: action.targetWidgetId
              };
              this.router.navigate([action.navigateTo], { state: stateData });
            }
          }
        }


        // Always make the API call (Submit, Add Record, Cancel all supported)
        console.log('Making API call to:', action.apiUrl, 'with payload:', payload, 'and options:', options);
        this.http.post(action.apiUrl, payload, options).subscribe({
          next: (res: any) => {

            let parsedResponse: any;

            if (typeof res === 'string') {
              try {
                parsedResponse = JSON.parse(res);
              } catch (e) {
                console.error('Failed to parse response as JSON:', res);
                this.snackBar.open('Invalid response format from server', 'Close');
                return;
              }
            } else {
              parsedResponse = res;
            }

            if (isSubmitCalculate) {
              console.log('API call success:', res);
              // Now process the response to create the tables
              this.processSubmitCalculateResponse(parsedResponse);
            }
            if (isSubmitSingle && this.data.NoResponseTable === true) {
              console.log("inside submit single")
              console.log('Second API success:', res);
              // this.renderTableFromResponse(res, true);
            }
            if (isSubmitSingle) {
              const isNoResponseTable = this.toBooleanFlag(this.data?.NoResponseTable);

              if (isNoResponseTable) {
                this.showQuoteCreatedSuccessMessage();
              }

              if (action.navigateTo) {
                const stateData = {
                  submittedData: submittedRow,
                  sourceWidgetId: this.data.widgetId,
                  targetWidgetId: action.targetWidgetId
                };
                this.router.navigate([action.navigateTo], { state: stateData });
              }
            }
            if (isSubmitPrice || isCalculatePrice) {
              try {
                const parsed = (typeof res === 'string') ? JSON.parse(res) : res;

                const optimizedPrice =
                  parsed?.responseList?.[1]?.price_optimization?.[0]?.data?.optimized_price;
                console.log('optimizedPrice', optimizedPrice);

                if (optimizedPrice !== undefined && optimizedPrice !== null) {
                  this.optimizedPrice = String(optimizedPrice);
                  // Show as a block (snackbar)
                  this.snackBar.open(`Optimized Price: ${optimizedPrice}`, 'Close', {
                    duration: 8000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['success-snackbar']
                  });

                  // OPTIONAL: also store it if you want to render it in the template later
                  // this.optimizedPrice = optimizedPrice;
                }
              } catch (e) {
                // ignore parse failures
              }
            }
            if (isSubmit) {
              console.log("inside issubmit condition second api calll");
              const itemValue = payload?.requestData?.item;
              const materialValue = payload?.requestData?.material;
              const size = payload?.requestData?.size;

              const secondPayload: any = {
                item: itemValue ? [itemValue] : [],
                base_item: ["Yes"]
              };
              const thirdPayload: any = {
                item: itemValue ? [itemValue] : [],
                material: materialValue ? [materialValue] : [],
                size: size ? [size] : [],
              };
              const rationalizeRaw: Record<string, any> = {
                size: payload.requestData.size,
                material: payload.requestData.material,
                type: payload.requestData.type
              };
              if (isSubmitPrice || isCalculatePrice) {
                secondPayload.rationalize = rationalizeRaw;
                secondPayload.base_item = "Yes";
              }
              if (action.updateApiUrl && secondPayload.item.length > 0) {
                this.http.post(action.updateApiUrl, secondPayload, options).subscribe({
                  next: (updateRes: any) => {
                    console.log('Second API success:', updateRes);
                    // this.globalFilterService.showRationalizeSection = true;
                    const newData = updateRes?.data || updateRes || [];
                    this.submitSuccess.emit({ widgetId: this.data?.widgetId });
                    this.globalFilterService.setTableData(newData);
                    this.renderTableFromResponse(updateRes, true);
                  },
                  error: (err) => {
                    const msg = (err.error && typeof err.error === 'string')
                      ? err.error
                      : (err.error?.message || err.message || 'Second API failed.');
                    this.snackBar.open(msg, 'Close', {
                      duration: 5000,
                      horizontalPosition: 'right',
                      verticalPosition: 'top',
                      panelClass: ['error-snackbar']
                    });
                  }
                });
              }

              const successMessage =
                this.friendlyMessageFromResponse(res) ||
                'Your workflow processed successfully.';
              this.snackBar.open(successMessage, 'Close', {
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['success-snackbar']
              });
            }

            // keep Add Record / Cancel logic as you already have
          },
          error: (err) => {
            const errorMessage = (err.error && typeof err.error === 'string')
              ? err.error
              : (err.error?.message || err.message || 'An unknown error occurred.');
            this.snackBar.open(errorMessage, 'Close', {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['error-snackbar']
            });
          }
        });

      }
      else if (action.label === 'Cancel') {
        this.multipleTables = [];
        this.isSubmitDisabled = true;
        this.isAddRecordDisabled = false;
        this.isTableLocked = false;
        this.globalFilterService.clearAllFilters();
        this.snackBar.open('Action cancelled', 'Close', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['info-snackbar']
        });
      }
      else if (action.label === 'Reset') {
        this.globalFilterService.resetDashboardState();
        this.snackBar.open('Action reset', 'Close', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['info-snackbar']
        });
      }
      else {
        this.snackBar.open(
          `Action '${action.label}' is missing the 'apiUrl' property.`,
          'Close',
          {
            duration: 7000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['error-snackbar']
          }
        );
      }
    };

    if (action.confirmation) {
      this.dialogService.open(action.confirmation).subscribe(confirmed => {
        if (confirmed) performAction();
      });
    } else {
      performAction();
    }
  }


  processSubmitCalculateResponse(response: any) {
    try {
      const dealDetailsData = response?.responseList?.[1]?.deal_details?.[0]?.data;

      if (!dealDetailsData) {
        throw new Error('Deal details data is missing or in an unexpected format.');
      }

      const firstTableData = {
        'Sales After Discount(USD)': dealDetailsData.sales_after_discount ?? 'N/A',
        'Sales Before Discount(USD)': dealDetailsData.sales_before_discount ?? 'N/A',
        'Total Discount(USD)': dealDetailsData.total_discount ?? 'N/A'
      };

      const secondTableData = {
        'Previous Sales(USD)': dealDetailsData.previous_sales ?? 'N/A',
        'Deal Impact(USD)': dealDetailsData.deal_impact ?? 'N/A'
      };

      const newResultTables = [
        {
          columns: ['Sales After Discount(USD)', 'Sales Before Discount(USD)', 'Total Discount(USD)'],
          tableData: [firstTableData],
          isResultTable: true,
          fileName: 'Final Sales'
        },
        {
          columns: ['Previous Sales(USD)', 'Deal Impact(USD)'],
          tableData: [secondTableData],
          isResultTable: true,
          fileName: 'Deal Impact'
        }
      ];

      // ───────────────────────────────────────────────────────
      // Keep existing tables, append only the new result ones
      // ───────────────────────────────────────────────────────
      this.multipleTables = [
        ...this.multipleTables,          // ← all previous tables stay
        ...newResultTables               // ← add the two new ones
      ];

      console.log('Updated multipleTables (appended):', this.multipleTables);

      // Optional: scroll to bottom or highlight new tables
      // this.cdr?.detectChanges();

    } catch (error) {
      console.error('Error processing calculate response:', error);
      this.snackBar.open('Error displaying results', 'Close', { duration: 6000 });
    }
  }





  refreshTable(): void {
    this.loadAndRenderTable(this.currentFilters);
  }

  // Extract a concise, friendly message from various API response shapes
  private friendlyMessageFromResponse(res: any): string | null {
    try {
      if (!res) return null;

      // If server returned a JSON string, try to parse it
      if (typeof res === 'string') {
        try {
          const parsed = JSON.parse(res);
          res = parsed;
        } catch (e) {
          // Not JSON — return short string if it's small
          return res.length > 200 ? res.substring(0, 200) + '...' : res;
        }
      }

      // If response is object, prefer specific fields
      if (typeof res === 'object') {
        if (res.commitStatus) return String(res.commitStatus);
        if (res.message) return String(res.message);
        if (res.commitMessage) return String(res.commitMessage);
        if (res.responseList && typeof res.responseList === 'string') return res.responseList;
        // fallback to a short JSON summary
        const summary = JSON.stringify(res);
        return summary.length > 200 ? summary.substring(0, 200) + '...' : summary;
      }

      return String(res);
    } catch (err) {
      return null;
    }
  }

  private toBooleanFlag(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === 'true' || normalized === '1' || normalized === 'yes';
    }

    return false;
  }

  private showQuoteCreatedSuccessMessage(): void {
    this.snackBar.open(
      'Quote Added Successfully!',
      '',
      {
        duration: 2600,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['quote-created-snackbar']
      }
    );
  }

  private showQuoteDetailsRequiredMessage(): void {
    this.snackBar.open(
      'Please Enter Quote Details',
      '',
      {
        duration: 2400,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['quote-created-error-snackbar']
      }
    );
  }

  private shouldBlockSubmitSingleForMissingQuoteDetails(row: Record<string, any>): boolean {
    const quoteRequiredKeys = [
      'quote_name',
      'customer',
      
    ];

    const hasAddQuoteShape = quoteRequiredKeys.some((key) =>
      Object.prototype.hasOwnProperty.call(row || {}, key)
    );
    if (!hasAddQuoteShape) {
      return false;
    }

    return quoteRequiredKeys.some((key) => this.isValueEmpty(this.firstValue(row?.[key])));
  }

  private firstValue(value: any): any {
    return Array.isArray(value) ? value[0] : value;
  }

  private isValueEmpty(value: any): boolean {
    if (value === undefined || value === null) {
      return true;
    }

    if (typeof value === 'string') {
      return value.trim().length === 0;
    }

    return false;
  }

  showError(errorStack: string): void {
    this.dialogService.open({
      title: 'Error Stack',
      message: errorStack,
      showActions: false,
      isError: true
    });
  }

  ngOnDestroy(): void {
    this.filterSub?.unsubscribe();
    this.resetStateSubscription?.unsubscribe();
    if (this.tableDataSubscription) {
      this.tableDataSubscription.unsubscribe();
    }
  }
}
